import { prettySize } from '@uikit/ui-utils/dist/@uikit/ui-utils';

/**
 * Human readable size filter
 * @example {{ 12345 | size }}
 */
export default function (value, arg) {
  if (value !== undefined && value !== null) {
    return prettySize(value, { isFixed: true, precision: 2 });
  }
  return '';
}
